import { render, staticRenderFns } from "./uploadPosterImage.vue?vue&type=template&id=27261d8e&scoped=true"
import script from "./uploadPosterImage.vue?vue&type=script&lang=js"
export * from "./uploadPosterImage.vue?vue&type=script&lang=js"
import style0 from "./uploadPosterImage.vue?vue&type=style&index=0&id=27261d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27261d8e",
  null
  
)

export default component.exports